export default __webpack_public_path__ + "static/media/reward_pool.bddfcd2b.png";